import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useCentroCustoOutletContext } from 'pages/CentroCusto.context'
import { useParams } from 'react-router-dom'
import { centroCusto } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'

export default function ExcluirCentroCusto() {
    const { id } = useParams()
    const { data } = useCentroCustoOutletContext()
    const node = data?.find(item => item.id === Number(id))
    const setCostCenterId = useStore(state => state.setCostCenterId)
    const { mutateAsync, isLoading } = centroCusto.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!node) return null

    const handleSubmit = () =>
        mutateAsync(node.id, {
            onSuccess: () => {
                toast.success('Centro de custo excluído com sucesso')
                setCostCenterId(-1)
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <ConfirmarExclusao
            permissao={['delete', 'CentrosDeCusto']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title={
                <>
                    Realmente deseja excluir o centro custo{' '}
                    {node.nomeCentroCusto}?
                </>
            }
        />
    )
}
